import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { splicedItems } from '../../utils/splicedItems.esm.js';
import styles from './StepperStaticSection.module.esm.js';

var StepperStaticSection = function (_a) {
    var _b = _a.fields, body = _b.body, heading = _b.heading, items = _b.items, theme = _b.theme, link = _b.link, internalName = _b.internalName, decorativeShape = _b.decorativeShape, id = _a.id, dataCy = _a["data-cy"];
    var itemsPerRow = items.length === 4 ? 4 : 3;
    var itemsToRender = splicedItems(items, itemsPerRow)
        .map(function (itemsRow) { return itemsRow.map(function (item) { return ({ item: item, layoutInfo: itemsRow.length }); }); })
        .flat();
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.root, styles[theme]), "data-cy": dataCy, id: id, sectionName: internalName },
        decorativeShape && React.createElement(BaseNucleobaseComponent, { source: decorativeShape }),
        React.createElement("div", { className: "nv-container" },
            React.createElement(NvMarkdownInline, { element: "h2", elementWrapper: NvHeading, level: 1 }, heading),
            React.createElement(Grid, { className: classNames(styles.grid, styles.gridBody), withoutContainer: true }, body && React.createElement(NvMarkdown, { className: classNames('nv-subheading-1-book', styles.body) }, body)),
            React.createElement(Grid, { className: styles.grid, component: "ul", withoutContainer: true }, itemsToRender.map(function (item, key) { return (React.createElement(BaseNucleobaseComponent, { classes: { root: styles["gridItem".concat(item.layoutInfo)] }, key: key, source: item.item })); })),
            link && (React.createElement("div", { className: styles.actions },
                React.createElement(BaseNucleobaseComponent, { classes: { link: 'nv-button' }, source: link }))))));
};

export { StepperStaticSection as default };
//# sourceMappingURL=StepperStaticSection.esm.js.map
